import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { grey } from '@mui/material/colors';
import { BulkDhcpReservationRowEntry } from '../../../../hooks/useBulkDhcpReservationForm';
import BulkDhcpReservationRow from './BulkDhcpReservationRow';
import dialogStyles from '../../common/dialogStyles';

interface BulkDhcpReservationFormProps {
  entries: BulkDhcpReservationRowEntry[];
  submitAttempted: boolean;
  duplicateDescriptions: string[];
  allowedInputCharacters: RegExp;
  maxDescriptionLength: number;
  onDescriptionChange: (ipAddress: string, value: string) => void;
  onBlur: (ipAddress: string) => void;
}

const BulkDhcpReservationForm: React.FC<BulkDhcpReservationFormProps> = ({
  entries,
  submitAttempted,
  duplicateDescriptions,
  allowedInputCharacters,
  maxDescriptionLength,
  onDescriptionChange,
  onBlur,
}) => {
  return (
    <DialogContent sx={dialogStyles.dialogContentForm}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          maxHeight: '55vh',
          overflowY: 'auto',
          paddingRight: 1,
        }}
      >
        {entries.map((entry, index) => (
          <React.Fragment key={entry.row.ip_address}>
            {index > 0 && <Divider sx={{ borderColor: grey[300] }} />}
            <BulkDhcpReservationRow
              row={entry.row}
              description={entry.description}
              touched={entry.touched}
              submitAttempted={submitAttempted}
              isDuplicate={duplicateDescriptions.includes(entry.description.trim().toLowerCase())}
              allowedInputCharacters={allowedInputCharacters}
              maxDescriptionLength={maxDescriptionLength}
              onDescriptionChange={onDescriptionChange}
              onBlur={onBlur}
            />
          </React.Fragment>
        ))}
      </Box>
    </DialogContent>
  );
};

export default BulkDhcpReservationForm;
